import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import Icons from './icons';
import ActionButton from '@/components/ActionButton'
//import SidebarHelp from '@/components/SidebarHelp'
import TooltipIcon from '@/components/TooltipIcon'
//import NextStepButton from '@/components/NextStepButton'
import ConfirmDialog from '@/components/ConfirmDialog'
import theme from './theme'

import * as directives from 'vuetify/lib/directives'

Vue.use(Vuetify, directives);

Vue.component('action-button', ActionButton);
//Vue.component('sidebar-help', SidebarHelp);
Vue.component('tooltip-icon', TooltipIcon);
//Vue.component('next-step-button', NextStepButton);
Vue.component('confirm-dialog', ConfirmDialog);

// https://coolors.co/50514f-f25f5c-ffe066-247ba0-70c1b3

export default (i18n) => new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },  
  icons: {
      iconfont: 'mdiSvg',
      values: Icons
    },
    /*
    theme: {
      options: { customProperties: true, variations: false },
      themes: {
        light: {
          primary: '#F25F5C',
          secondary: '#70C1B3',
          accent: '#247BA0',
        },
      },
    },
    */
    theme: {
      dark: theme.globalTheme === 'dark',
      options: {
        customProperties: true
      },
      themes: {
        dark: theme.dark,
        light: theme.light
      }
    },
  });
